import { Component, OnDestroy, OnInit } from '@angular/core';
import { OAuth2Client } from '../../sdk/hydra';

import { Subscription } from 'rxjs';
import { BangumiProviderService } from '../bangumi-provider.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-developer-settings',
    imports: [],
    templateUrl: './developer-settings.component.html',
    styleUrl: './developer-settings.component.less'
})
export class DeveloperSettingsComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  oAuth2ClientList!: OAuth2Client[];
  clientName!: string;
  next?: string;
  first?: string;

  constructor(private bangumiProvider: BangumiProviderService,
              private router: Router) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.listClient();
  }

  listClient(page?: string): void {
    this.subscription.add(
      this.bangumiProvider.listMyOAuth2Client(this.clientName, page)
        .subscribe({
          next: (data) => {
            this.oAuth2ClientList = data.data;
            this.next = data.next;
            this.first = data.first;
          }
        })
    );
  }

  newClient() {
    this.router.navigate(['settings', 'developer', 'client', 'new']).then(() => {});
  }

  editClient(clientId?: string) {
    this.router.navigate(['settings', 'developer', 'client', clientId], {queryParams: {mode: 'edit'}}).then(() => {});
  }

  editServiceClient(clientId?: string) {
    this.router.navigate(['settings', 'developer', 'client', clientId, 'service']).then(() => {});
  }
}
